import { t } from '../../i18n/i18n';

const setLanguage = (languageFilter) =>
  languageFilter?.map((filter) => ({
    ...filter,
    ...{ name: t(filter?.name) },
  }));

export default setLanguage;
